<template>
    <li :class="{'success': element.is_approved,}">
        <span :class="{'text-white': isSelectedForExport}">&nbsp;{{ element.element_full_name }}</span>
        <div style="padding-left: 22px" class="alert alert-info" v-if="element.ec_comment"><span class="fa fa-quote-left"></span> <Nl2br tag="span" :text="ecComment"/></div>
        <ul class="square-list">
            <TcElement v-for="child in element.children" :key="child.id" :element="child" :lesson="lesson"></TcElement>
        </ul>
    </li>
</template>

<script setup>
import { computed } from 'vue';
import State from '../../state/teachingCardStore';
import TcElement from './TcElement';
import Nl2br from "vue3-nl2br";

const props = defineProps(['element', 'lesson']);

const isSelectedForExport = computed(() => {
    return State.isSelectedForExport(props.lesson.calendar_id);
});

const ecComment = computed(() => {
    return typeof props.element.ec_comment === 'string' ? props.element.ec_comment : ''
})
</script>